<!-- Watch this thread!!! -->
<!-- https://github.com/devstark-com/vue-google-charts/issues/58 -->
<template>
	<v-row class="row_" no-gutters>
		<v-col>
			<template v-if="type == 'Map'">
				<g-chart
						class="chart_"
						:type="type"
						:data="data"
						:options="options"
						:settings="map_" />
			</template>
			<template v-else>
				<g-chart
						class="chart_"
						:type="type"
						:data="data"
						:options="options" />
			</template>
		</v-col>
	</v-row>
</template>

<script>
	export default {
		name: 'CardGChart',
		props: {
			type: String,
			data: Array,
			options: Object
		},
		data() {
			return {
				map_: {
					packages: ['map'],
					mapsApiKey: this.googleChartMapsApiKey
				}
			}
		}
	}
</script>

<style scoped>
	.row_ {
		height: 100%;
		width: 100%;
	}
	.chart_ {
		height: 100%;
		width: 100%;
		padding: 5%;
	}
</style>
